'use strict';

window.TIPOS_INDICADORES = [
  { id: 'boolean', descricao: 'Sim/Não' },
  { id: 'percentual', descricao: 'Percentual', temFaixas: true },
  { id: 'texto', descricao: 'Seleção: Baixa, Média, Alta' },
  { id: 'valor', descricao: 'Valor', temFaixas: true },
  { id: 'contagem_plantas', descricao: 'Entre nós atacados', temFaixas: true }
];

angular.module('webAgro1App').factory('IndicadoresOcorrenciasService', function($http) {
  return {
    list: function() {
      return $http.get(`${SERVER + API_VERSION }/ocorrencias/indicadores`);
    }
  };
});
